<div class="w-full p-8 bg-zinc-100 mon-portfolio users-ctnr flex-col justify-start items-start gap-2.5 inline-flex">
  <div class="w-full bg-zinc-100 flex-col justify-start items-start gap-2.5 inline-flex">
    <app-breadcrumb [items]="breadcrumbItems"></app-breadcrumb>
    <div class="self-stretch h-full flex-col justify-start items-start gap-5 flex">
    <div class="self-stretch rounded-lg bg-white shadow-sm p-6 px-8">
      <div class="self-stretch mb-2 flex-col justify-start items-center gap-6 flex">
        <div class="self-stretch flex-col justify-start items-start gap-6 flex">
          <div class="self-stretch flex-col justify-start items-start gap-5 flex">
            <div class="self-stretch title-ctnr justify-start items-start gap-4 inline-flex lg:flex-row flex-col">
              <div class="grow shrink basis-0 flex-col justify-start items-start gap-1 inline-flex">
                <div class="self-stretch text-gray-900 text-4xl font-semibold leading-[38px]">
                  Liste des utilisateurs
                </div>
                <div class="self-stretch desc text-slate-600 text-base mt-4 leading-normal">
                  Vous trouverez ci-dessous la listes des utilisateurs
                </div>

              </div>
              <div class="justify-start items-center gap-3 flex">

                <button [routerLink]="['../createUser']"
                  class="transition hover:bg-gray-200 px-4 py-2.5 bg-white rounded-lg shadow border border-gray-300 justify-center items-center gap-2 flex">
                  <div class="relative">
                    <img src="assets/icons/plus.png" alt="plus" style="width: 22px; height: 22px;"/>
                  </div>
                  <div class="text-slate-700 text-base transition font-semibold font-['Inter'] leading-tight">
                    Créer un utilisateur
                  </div>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Tableau -->
      <div class="self-stretch h-full flex-col justify-start items-center gap-4 flex">
        <div class="self-stretch h-full flex-col justify-start items-start gap-8 flex">
          <div class="self-stretch h-full flex-col justify-start items-start gap-4 flex">
            <div
            class="bg-green-500 border border-400 text-white-700 px-4 py-3 rounded relative"
            role="alert"
            *ngIf="deleted"
          >
            <strong class="font-bold">Réussie</strong>
            <span class="block sm:inline"> Utilisateur supprimé avec succès</span>
          </div>
          <div
            class="bg-red-200 border border-400 text-white-700 px-4 py-3 rounded relative"
            role="alert"
            *ngIf="deleteError"
          >
            <strong class="font-bold">Erreur</strong>
            <span class="block sm:inline">Erreur lors de la suppression de l'utilisateur</span>
          </div>
          </div>
        </div>
      </div>

      <!-- Second Tableau -->
      <div class="tab-filter h-[68px] flex items-center ml-auto">
        <div class="py-3 rounded-xl flex items-center gap-9">
          <div class="other-filters">
            <div class="search-ctnr flex items-center gap-2">
              <div class="h-11 flex items-center gap-1.5">
                <input
                  type="text"
                  class="bg-white rounded-lg shadow border border-gray-300"
                  matInput
                  placeholder="Rechercher"
                  [formControl]="searchCtrl"
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
      class="self-stretch h-full flex-col justify-start items-center gap-4 flex"
    >
      <div
        class="self-stretch h-full flex-col justify-start items-start gap-8 flex"
      >
        <div
          class="self-stretch h-full flex-col justify-start items-start gap-4 flex"
        >
          <div
            class="tableau-ctnr liste-etud self-stretch h-full flex-col justify-start items-start gap-4 flex relative overflow-x-scroll rounded-lg"
          >
            <table
              class="w-full tab-users text-sm text-left rtl:text-right text-gray-500 dark:text-gray-400"
            >
              <thead
                class="text-sm text-white bg-green-700 dark:bg-gray-700 dark:text-gray-400"
              >
                <tr>
                  <th scope="row" class="px-6 py-3">IUF</th>
                  <th scope="row" class="px-6 py-3">Nom</th>
                  <th scope="row" class="px-6 py-3">Prenom</th>
                  <th scope="row" class="px-6 py-3">Email</th>
                  <th scope="row" class="px-6 py-3">Profil</th>
                  <th scope="row" class="px-6 py-3">Actions</th>

                </tr>
              </thead>


              <tbody>
                <tr
                  *ngFor="let Users of displayedManagers$ | async"
                  class="bg-white border-b dark:bg-gray-800 dark:border-gray-700 ng-star-inserted"
                >
                <td

                class="px-6 py-4 inter-medium font-medium text-gray-900 whitespace-nowrap dark:text-white"
              >
                {{ Users.iuf }}
              </td>
                  <td

                    class="px-6 py-4 inter-medium font-medium text-gray-900 whitespace-nowrap dark:text-white"
                  >
                    {{ Users.firstname }}
                  </td>
                  <td  class="px-6 py-4 inter-regular f14 text-gray-900">
                    {{ Users.lastname }}
                  </td>
                  <td  class="px-6 py-4 inter-regular f14 text-gray-900">
                    {{ Users.email }}
                  </td>
                  <td  class="px-6 py-4 inter-regular f14 text-gray-900">
                    {{ profileId(Users.roles) }}
                  </td>
                  <td  class="text-center">
                    <!--  <button
                        class="action-btn1 cst-transition three-dots p-1 text-gray-700 w-fit text-center"
                      > -->
                    <button
                      class="btn focus:outline-none hover:bg-gray-100 focus:ring-2 focus:ring-gray-100 p-1 text-gray-700 text-center"
                      (click)="toggleModalDetails(Users)"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke-width="1"
                        style="width: 1rem"
                        stroke="currentColor"
                        class="h-6 text-gray-800 dark:text-white"
                      >
                        <path
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          d="M2.036 12.322a1.012 1.012 0 0 1 0-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178Z"
                        />
                        <path
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          d="M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z"
                        />
                      </svg>
                      <div
                        class="actions-panel text-left rounded-lg shadow bg-white cst-transition"
                      >
                        <p
                          id=""
                          class="inter-regular text-left py-2 px-3 text-gray-700 w-full pr-db f14 option cst-transition"
                        >
                          Afficher
                        </p>
                      </div>
                    </button>
                    <button
                    *ngIf="Users.roles.at(0).id != 1"
                      (click)="showSuppModal(Users)"
                      class="btn focus:outline-none hover:bg-gray-100 focus:ring-2 focus:ring-gray-100 p-1 text-gray-700 text-center"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke-width="1"
                        stroke="currentColor"
                        style="width: 1rem"
                        class="h-6"
                        [style.color]="'f04438'"
                      >
                        <path
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          d="m14.74 9-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 0 1-2.244 2.077H8.084a2.25 2.25 0 0 1-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 0 0-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 0 1 3.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 0 0-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 0 0-7.5 0"
                        />
                      </svg>
                      <div
                        class="actions-panel text-left rounded-lg shadow bg-white cst-transition"
                      >
                        <p
                          id=""
                          class="inter-regular text-left py-2 px-3 text-gray-700 w-full pr-db f14 option cst-transition"
                        >
                          Supprimer
                        </p>
                      </div>
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div
            class="tableau-ctnr mb-6 self-stretch h-full justify-end items-end gap-4 flex relative overflow-x-auto rounded-lg"
          >
            <div
              class="flex items-center justify-end space-x-2 rounded-b dark:border-gray-600"
            >
              <!--<div
                class="pagination-controls flex justify-end items-center mt-4"
               >
                <button
                  type="button"
                  class="text-white inline-flex items-center bg-green-700 hover:bg-green-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-red-600 dark:hover:bg-red-700 dark:focus:ring-red-800"
                  [disabled]="currentPage4Users === 1"
                  (click)="previousPage4Users()"
                >
                  Précédent
                </button>

                <span class="px-4"
                  >Page {{ currentPage4Users }} sur
                  {{ totalPages4Users }}</span
                >

                <button
                  type="button"
                  class="text-white inline-flex items-center bg-green-700 hover:bg-green-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-red-600 dark:hover:bg-red-700 dark:focus:ring-red-800"
                  [disabled]="currentPage4Users === totalPages4Users"
                  (click)="nextPage4Users()"
                >
                  Suivant
                </button>
              </div> -->
              <mat-paginator
  #paginator
  [length]="totalElements"
  [pageSize]="pageSize"
  [pageSizeOptions]="[5, 10, 20, 50]"
  showFirstLastButtons>
              </mat-paginator>
            </div>
          </div>
        </div>
      </div>
    </div>

    </div>
  </div>
</div>

</div>
<div
  *ngIf="showDetails"
  tabindex="-1"
  aria-hidden="true"
  style="z-index:99999999;"
  class="bg-opacity-70 bg-gray-100 overflow-y-auto overflow-x-hidden fixed top-0 right-0 left-0 z-50 outline-none focus:outline-none justify-center items-center flex h-full max-h-full"
>
  <div class="relative w-full my-6 mx-w-md max-w-6xl" style="max-height: 90vh;">
    <!-- Modal content -->
    <div class="relative bg-white rounded-lg shadow dark:bg-gray-700">
      <!-- Modal header -->
      <div
        class="flex items-center justify-between p-4 md:p-5 border-b rounded-t dark:border-gray-600"
      >
        <h2
          class="text-lg text-center font-semibold text-gray-900 dark:text-white"
        >
          Détails de l'utilisateur
          {{ ligneDetails.firstname + " " + ligneDetails.lastname }}
        </h2>
        <button
          type="button"
          (click)="closeModalDetails()"
          class="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-0 h-8 ms-auto inline-flex justify-center items-center dark:hover:bg-gray-600 dark:hover:text-white"
          data-modal-toggle="crud-modal"
        >
          <svg
            style="width: 0.75rem;"
            aria-hidden="true"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 14 14"
          >
            <path
              stroke="currentColor"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"
            />
          </svg>
          <span class="sr-only">Fermer</span>
        </button>
      </div>
      <!-- Modal body -->
      <div class="p-4 md:p-5">
        <div *ngIf="!update" class="grid gap-4 mb-4 grid-cols-2 m-0">
          <div
          *ngIf="activated"
          class="p-4 mb-4 text-sm text-green-800 rounded-lg bg-green-50 dark:bg-gray-800 dark:text-green-400"
           role="alert">
           <span class="font-medium">Reussie!</span> Utilisateur activé !
         </div>
         <div                   *ngIf="desactivated"
         class="p-4 mb-4 text-sm text-green-800 rounded-lg bg-green-50 dark:bg-gray-800 dark:text-green-400"
         role="alert">
           <span class="font-medium">Reussie!</span> Utilisateur desactivé !
         </div>
         <div
         *ngIf="error"
          class="p-4 mb-4 text-sm text-red-800 rounded-lg bg-red-50 dark:bg-gray-800 dark:text-red-400" role="alert">
          <span class="font-medium">Erreur!!</span> Erreur lors du changement de statut !
        </div>
          <div class="justify-end col-span-2 sm:col-span-2">
            <label class="inline-flex items-center cursor-pointer">
              <input type="checkbox"   (change)="onCheckedChange($event)" class="sr-only peer" [checked]="active">
              <div class="relative w-14 h-7 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 dark:peer-focus:ring-blue-800 rounded-full peer dark:bg-gray-700 peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:start-[4px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-6 after:w-6 after:transition-all dark:border-gray-600 peer-checked:bg-blue-600"></div>
              <span *ngIf="active" class="ms-3 text-sm font-medium text-gray-900 dark:text-gray-300">Activé</span>
              <span *ngIf="!active" class="ms-3 text-sm font-medium text-gray-900 dark:text-gray-300">Désactivé</span>
            </label>
           </div>

          <div class="col-span-2 sm:col-span-1">
                  <h3
              class="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
            >
              IUF
            </h3>
            <p
              class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 dark:bg-gray-600 dark:border-gray-500 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500"
            >
              {{ ligneDetails.iuf}}
            </p>
          </div>
          <div class="col-span-2 sm:col-span-1">
            <h3
              class="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
            >
              Nom Prénom
            </h3>
            <p
              class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 dark:bg-gray-600 dark:border-gray-500 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500"
            >
              {{ ligneDetails.firstname + " " + ligneDetails.lastname }}
            </p>

          </div>
          <div class="col-span-2 sm:col-span-1">
            <h3
              class="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
            >
              Email
            </h3>
            <p
              class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 dark:bg-gray-600 dark:border-gray-500 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500"
            >
              {{ ligneDetails.email }}
            </p>
          </div>
          <div class="col-span-2 sm:col-span-1">
            <h3
              class="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
            >
              Sexe
            </h3>
            <p
              class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 dark:bg-gray-600 dark:border-gray-500 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500"
            >
              {{ ligneDetails.gender.id == 1 ? 'Homme' : 'Femme' }}
            </p>
          </div>
          <!--  <div class="col-span-2 sm:col-span-1">
            <h3
              class="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
            >
              Numéro de Téléphone
            </h3>
            <p
              class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 dark:bg-gray-600 dark:border-gray-500 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500"
            >
              {{ ligneDetails.phoneNumberOne }}
            </p>
          </div> -->

         <div class="col-span-2 sm:col-span-1">
            <h3
              class="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
            >
              Status
            </h3>
            <p
              class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 dark:bg-gray-600 dark:border-gray-500 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500"
            >
              {{ ligneDetails.active === null || ligneDetails.active === true ? 'Activé':'Descativé' }}
            </p>
          </div>
          <div class="col-span-2 sm:col-span-1">
            <h3
              class="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
            >
              Date de création
            </h3>
            <p
              class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 dark:bg-gray-600 dark:border-gray-500 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500"
            >
              {{ ligneDetails.createdAt }}
            </p>
          </div>
        </div>
        <form *ngIf="update" class="w-full grow shrink " [formGroup]="createUserForm">
          <div>
            <div class="lg:flex justify-end">
              <div
                class="bg-green-500 border border-400 text-white-700 px-4 py-3 rounded relative"
                role="alert"
                *ngIf="notification"
              >
                <strong class="font-bold">Reussie!</strong>
                <span class="block sm:inline"> Utilisateur moidifié avec succès!</span>
              </div>
              <div
                class="bg-red-200 border border-400 text-white-700 px-4 py-3 rounded relative"
                role="alert"
                *ngIf="error"
              >
                <strong class="font-bold">Erreur!</strong>
                <span class="block sm:inline">Erreur lors de la modification de l'utilisateur </span>
              </div>
              <div
                class="bg-red-200 border border-400 text-white-700 px-4 py-3 rounded relative"
                role="alert"
                *ngIf="valid"
              >
                <strong class="font-bold">Erreur!</strong>
                <span class="block sm:inline">Merci de remplir tous les champs </span>
              </div>
            </div>
          </div>
          <div class="form-fields-ctnr w-full self-stretch justify-start items-start gap-6 inline-flex">
              <div class="w50 pr-db pt-6 justify-start items-center gap-5">
                  <label class="mb10 pr-db font-medium inter-medium f14 color-gray-900 w-full" for="email">Prenom</label>
                  <input
                  type="text"
                  id="email"
                  class="w-full  pr-db mat-mdc-input-element self-stretch px-3.5 py-2.5 bg-white rounded-lg shadow border border-gray-300 justify-start items-center gap-2 inline-flex "
                  formControlName="firstname"
                />

                </div>
              <div class="w50 pr-db pt-6 justify-start items-center gap-5 ">
                <label class="mb10 pr-db font-medium inter-medium f14 color-gray-900 w-full" for="lastname">Nom</label>
                <input
                  type="text"
                  id="lastname"
                  class="w-full  pr-db mat-mdc-input-element self-stretch px-3.5 py-2.5 bg-white rounded-lg shadow border border-gray-300 justify-start items-center gap-2 inline-flex "

                  formControlName="lastname"
                />

              </div>
          </div>

          <div class="form-fields-ctnr w-full self-stretch justify-start items-start gap-6 inline-flex">
              <div class="w50 pr-db pt-6 justify-start items-center gap-5">
                <label class="mb10 pr-db font-medium inter-medium f14 color-gray-900 w-full" for="email">Adresse e-mail</label>
                <input
                type="text"
                id="email"
                class="w-full  pr-db mat-mdc-input-element self-stretch px-3.5 py-2.5 bg-gray-100 rounded-lg shadow border border-gray-300 justify-start items-center gap-2 inline-flex "
                formControlName="email"
                [disabled]="true"
                />
              </div>
              <div class="w50 pr-db pt-6 justify-start items-center gap-5 ">
                <label class="mb10 pr-db font-medium inter-medium f14 color-gray-700 w-full" for="typeactivite">Sexe</label>

                <select
                formControlName="selectedGender"
                id="sexe"
                class="w-full pr-db px-3.5 py-2.5 bg-white rounded-lg shadow border border-gray-300 gap-2"
              >
              <option value="" disabled selected class="text-gray-200">
                Renseignez le sexe
              </option>
                <option *ngFor="let gender of genders" [value]="gender.id">
                  {{ gender.name }}
                </option>
              </select>
            </div>

          </div>
          <div class="form-fields-ctnr w-full self-stretch justify-start items-start gap-6 inline-flex">
            <div class="w50 pr-db pt-6 justify-start items-center gap-5 ">
              <label class="mb10 pr-db font-medium inter-medium f14 color-gray-900 w-full" for="typeactivite">Roles</label>

              <select
              formControlName="selectedProfil"
              id="profils"
              class="w-full pr-db px-3.5 py-2.5 bg-white rounded-lg shadow border border-gray-300 gap-2"
            >
            <option value="" disabled selected class="text-gray-200">
              Renseignez le role
            </option>
            <option *ngFor="let role of roles" [value]="role.id">
              {{ role.libelle }}
            </option>
            </select>
          </div>

          </div>



        </form>


        <button
        *ngIf="!update"
        type="submit"
        (click)="showFormUpdate()"
        class="font-semibold text-white m-4 inline-flex items-center bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-red-700 dark:focus:ring-blue-800 ml-0"
      >
        Modifier
      </button>
        <button
        *ngIf="!update"
          type="submit"
          (click)="closeModalDetails()"
          class="font-semibold text-white inline-flex items-center bg-red focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-red-600 dark:hover:bg-red-700 dark:focus:ring-red-800"
        >
          Fermer
        </button>
        <button
        *ngIf="update"
        type="submit"
        (click)="hideFormUpdate()"
        class="text-white inline-flex items-center bg-red hover:bg-red-800 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-red-600 dark:hover:bg-red-700 dark:focus:ring-red-800"

      >
        Annuler
      </button>
      <button
      *ngIf="update"
      type="submit"
      (click)="updateUser()"
      class="text-white m-4 inline-flex items-center bg-green-700 hover:bg-green-800 focus:ring-4 focus:outline-none focus:ring-green-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-green-600 dark:hover:bg-red-700 dark:focus:ring-green-800"
    >
      Enregistrer
    </button>
      </div>
    </div>
  </div>
</div>
<!-- Alerte avant Suppression de l'utilisateur -->
<div
  *ngIf="showModal"
  tabindex="-1"
  aria-hidden="true"
  class="bg-opacity-70 bg-gray-100 overflow overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none justify-center items-center flex"
>
  <div class="relative w-auto my-6 mx-auto max-w-6xl">
    <div class="relative p-4 w-full max-w-2xl max-h-full">
      <!-- Modal content -->
      <div class="relative bg-white rounded-lg shadow dark:bg-gray-700">
        <!--  -->
        <!-- Modal body -->
        <div class="p-4 md:p-5 space-y-4 items-center justify-center">
          <div class="flex justify-center items-center">
            <div
              class="mx-auto flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-full bg-red-100 sm:mx-0 sm:h-10 sm:w-10"
            >
              <svg
                class="h-10 w-10 text-red-600"
                fill="none"
                viewBox="0 0 24 24"
                stroke-width="1"
                stroke="currentColor"
                aria-hidden="true"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126zM12 15.75h.007v.008H12v-.008z"
                />
              </svg>
            </div>
          </div>
          <div class="flex justify-center items-center">
            <p
              class="text-xl text-center leading-relaxed text-gray-500 dark:text-gray-400"
            >
              Vous allez supprimer l'utilisateur {{ligneDetails.firstname +' '+ ligneDetails.lastname}}. Merci de confirmer.
            </p>
          </div>
          <div class="flex justify-center items-center">
            <button
             (click)="ddeleteUser()"
              type="button"
              class="w-full justify-center ml-3 rounded-md bg-green-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-green-500 sm:ml-3 sm:w-auto"
            >
              Confirmer
            </button>
            <button
              (click)="closeSuppModal()"
              type="button"
              class="mt-3 w-full justify-center ml-3 rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:mt-0 sm:w-auto"
            >
              Annuler
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- Alerte avant de désactiver l'utilisateur -->

<div
  *ngIf="showDesactiveModal"
  tabindex="-1"
  aria-hidden="true"
  class="bg-opacity-70 bg-gray-100 overflow overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none justify-center items-center flex"
>
  <div class="relative w-auto my-6 mx-auto max-w-6xl">
    <div class="relative p-4 w-full max-w-2xl max-h-full">
      <!-- Modal content -->
      <div class="relative bg-white rounded-lg shadow dark:bg-gray-700">
        <!--  -->
        <!-- Modal body -->
        <div class="p-4 md:p-5 space-y-4 items-center justify-center">
          <div class="flex justify-center items-center">
            <div
              class="mx-auto flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-full bg-red-100 sm:mx-0 sm:h-10 sm:w-10"
            >
              <svg
                class="h-10 w-10 text-red-600"
                fill="none"
                viewBox="0 0 24 24"
                stroke-width="1"
                stroke="currentColor"
                aria-hidden="true"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126zM12 15.75h.007v.008H12v-.008z"
                />
              </svg>
            </div>
          </div>
          <div class="flex justify-center items-center">
            <p
              class="text-xl text-center leading-relaxed text-gray-500 dark:text-gray-400"
            >
              Vous allez désactiver l'utilisateur {{ligneDetails.firstname +' '+ ligneDetails.lastname}}. Merci de confirmer.
            </p>
          </div>
          <div class="flex justify-center items-center">
            <button
             (click)="disableAccount()"
              type="button"
              class="w-full justify-center ml-3 rounded-md bg-green-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-green-500 sm:ml-3 sm:w-auto"
            >
              Confirmer
            </button>
            <button
              (click)="closeDesactiveModal()"
              type="button"
              class="mt-3 w-full justify-center ml-3 rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:mt-0 sm:w-auto"
            >
              Annuler
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- Alerte avant d'activer l'utilisateur -->
<div
  *ngIf="showActiveModal"
  tabindex="-1"
  aria-hidden="true"
  class="bg-opacity-70 bg-gray-100 overflow overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none justify-center items-center flex"
>
  <div class="relative w-auto my-6 mx-auto max-w-6xl">
    <div class="relative p-4 w-full max-w-2xl max-h-full">
      <!-- Modal content -->
      <div class="relative bg-white rounded-lg shadow dark:bg-gray-700">
        <!--  -->
        <!-- Modal body -->
        <div class="p-4 md:p-5 space-y-4 items-center justify-center">
          <div class="flex justify-center items-center">
            <div
              class="mx-auto flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-full bg-red-100 sm:mx-0 sm:h-10 sm:w-10"
            >
              <svg
                class="h-10 w-10 text-red-600"
                fill="none"
                viewBox="0 0 24 24"
                stroke-width="1"
                stroke="currentColor"
                aria-hidden="true"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126zM12 15.75h.007v.008H12v-.008z"
                />
              </svg>
            </div>
          </div>
          <div class="flex justify-center items-center">
            <p
              class="text-xl text-center leading-relaxed text-gray-500 dark:text-gray-400"
            >
              Vous allez ré-activer l'utilisateur {{ligneDetails.firstname +' '+ ligneDetails.lastname}}. Merci de confirmer.
            </p>
          </div>
          <div class="flex justify-center items-center">
            <button
             (click)="enbaleAccount()"
              type="button"
              class="w-full justify-center ml-3 rounded-md bg-green-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-green-500 sm:ml-3 sm:w-auto"
            >
              Confirmer
            </button>
            <button
              (click)="closeActiveModal()"
              type="button"
              class="mt-3 w-full justify-center ml-3 rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:mt-0 sm:w-auto"
            >
              Annuler
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
